import Constants from "../components/Constants";
export const baseUrl = Constants.HOST_WEBSITE === '3d-sofa' ? 'http://3d-sofa.com.ua/3dmodel.php' : 'https://ddn.ua/3dmodel.php';